import { useMemo } from 'react';

import SubActivityPrint from '../../sub-activity/sub-activity-print';
import InteractiveDragDisplay from '../../shared/interactive-drag-drop/interactive-drag-display';
import {
  InteractiveResponseTitle,
  InteractiveResponseViewScaler,
} from '../shared/interactive-response-shared';
import { InteractiveResponseContainer } from '../interactive-response.style';
import { ViewProps } from './settings/interactive-response.constants';
import { initialise } from './play/interactive-response-sequence.utils';
import * as Styled from './interactive-response-sequence-print.style';
import { ComponentAspectRatio } from '../../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../../shared/component-height/component-dimensions.style';
import { useContainerDimensions } from '../../shared/component-height/component-dimensions.hooks';
import { defaultDimensions } from '../interactive-response-shared.constants';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import InteractiveSequenceDropDisplay from './play/interactive-sequence-drop-display';

const InteractiveResponseSequencePrint = ({
  properties,
  subActivityProperties,
}: ViewProps & CommonPrintProps) => {
  const { dragItems, dropItems } = useMemo(() => {
    return initialise(
      properties.interactiveResponse.variant,
      properties.interactiveResponse.items
    );
  }, [
    properties.interactiveResponse.variant,
    properties.interactiveResponse.items,
  ]);

  const { setContainerElement } = useContainerDimensions({
    aspectRatio: 16 / 9,
  });

  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <InteractiveResponseContainer>
        <ComponentAspectRatio
          dimensions={properties.responseDimensionData || defaultDimensions}
        >
          <ComponentAbsoluteWrapper ref={setContainerElement}>
            <InteractiveResponseViewScaler>
              <InteractiveResponseTitle
                title={properties.interactiveResponse.title}
                subTitle={properties.interactiveResponse.subTitle}
              />

              <Styled.InteractiveResponsePrintDragZone>
                {dragItems.map((dragItem, index) => (
                  <Styled.InteractiveResponsePrintDragZoneItem
                    key={`${dragItem.id}-${index}`}
                  >
                    <InteractiveDragDisplay
                      imageUrl={dragItem.question.image?.small}
                      isFit={dragItem.question.image?.isFit}
                      description={dragItem.question.image?.description || ''}
                      baseColour={dragItem.question.baseColour}
                      variant={dragItem.question.variant}
                      text={dragItem.question.text}
                      richtext={dragItem.question.richtext}
                    />
                  </Styled.InteractiveResponsePrintDragZoneItem>
                ))}
              </Styled.InteractiveResponsePrintDragZone>

              <Styled.InteractiveResponsePrintDropZoneOuter>
                <Styled.InteractiveResponsePrintDropZone>
                  {dropItems.map(dropItem => (
                    <Styled.InteractiveResponsePrintDropZoneItem
                      key={dropItem.id}
                      $labelLength={properties.interactiveResponse.labelLength}
                    >
                      <InteractiveSequenceDropDisplay
                        label={dropItem.label}
                        labelLength={properties.interactiveResponse.labelLength}
                        labelBorder={properties.interactiveResponse.labelBorder}
                      />
                    </Styled.InteractiveResponsePrintDropZoneItem>
                  ))}
                </Styled.InteractiveResponsePrintDropZone>
              </Styled.InteractiveResponsePrintDropZoneOuter>
            </InteractiveResponseViewScaler>
          </ComponentAbsoluteWrapper>
        </ComponentAspectRatio>
      </InteractiveResponseContainer>
    </SubActivityPrint>
  );
};

export default InteractiveResponseSequencePrint;
